import React from "react";
import Layout from "../../../Layout";
import SearchMailboxSize from "./SearchMailboxSize";
import ListMailboxSize from "./ListMailboxSize";
import HeaderReports from "../../HeaderReports";
import useUserStore from "../../../../utils/storeApp";

const MailboxSize = () => {
  const { isUserLogedIn, userRole, userToken } = useUserStore((state) => ({
    isUserLogedIn: state.isUserLogedIn,
    userRole: state.userRole,
    userToken: state.userToken,
  }));

  return (
    <Layout>
      <HeaderReports />
      <ListMailboxSize />
      <SearchMailboxSize />
    </Layout>
  );
};

export default MailboxSize;
